window.lang2 = 
{
  "general": {
    "meta": {
      "tags": "Mots clés \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "404": {
      "title": "404 - Page non trouvée",
      "subtext_html": "Cette page n'est pas disponible. <a href=\"\/collections\/all\">Retourner au magasinage<\/a>"
    },
    "breadcrumbs": {
      "home": "Accueil",
      "home_link_title": "Retour à la page d'accueil"
    },
    "newsletter_form": {
      "title": "Newsletter",
      "newsletter_email": "Adresse e-mail",
      "submit": "Soumettre",
      "text":"Entrez votre adresse email",
      "noitice": "Don’t show this popup again",
      "go":"Aller",
      "ok":"ok",
      "subscribe": "subscribe"
    }, 
    "search": {
      "no_results_html": "Résultats de recherche pour \"{{ terms }}\"",
      "results_for_html": "Résultats de recherche pour \"{{ terms }}\"",
      "title": "Effectuez une recherche",
      "placeholder": "Chercher...",
      "submit": "Recherche",
      "category": "Select category", 
      "info_search": "Start typing to see products you are looking for.",
      "not_found": "No products found",
      "view_results": "View all results"
    },
    "date": {
      "year_text": "années",
      "month_text": "mois",
      "week_text": "semaines",
      "day_text": "journées",
      "year_singular_text": "années",
      "month_singular_text": "mois",
      "week_singular_text": "semaines",
      "day_singular_text": "journées",
      "hour_text": "Heures",
      "min_text": "Mins",
      "sec_text": "Secs",
      "hour_singular_text": "Heure",
      "min_singular_text": "Min",
      "sec_singular_text": "Sec"
    },
    "modal": {
      "wishlist_text": "Excl. affranchissement",
      "continue_shopping": "Continue",
      "go_to_wishlist": "Ma liste d'envies",
      "add_to_wishlist_message": "Venez d'ajouter à votre liste:",
      "cart_text": "Excl. affranchissement",
      "go_to_cart": "Aller au panier",
      "add_to_cart_message": "Vous venez d'ajouter cet article à votre caddie:",
      "qty": "Quantité:",
      "total": "Le total:"
    }
  },
  "header": {
    "settings": {
      "login": "Connectez-vous ou créez un compte",
      "register": "Enregistrer",
      "logout": "Se déconnecter",
      "my_account": "Mon compte",
      "wishlist": "Ma liste de vœux",
      "compare": "Comparer",
      "currency": "Devise",
      "newsletter_signup": "Inscription à la newsletter",
      "language": "vos Langues" ,
      "daily_deal": "Daily deal",
      "blog":"blog",
      "links":"Des liens",
      "shop":"Boutique"
    },
    "topbar": {
      "my_cart": "Mon panier",
      "search": "Search"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "{{ date }}",
      "by_admin":"Par {{ author }}",
      "older_post": "Article précédent",
      "newer_post": "Article suivant",
      "tags": "Tags",
      "comment_meta_html": "{{ author }} le {{ date }}",
      "read_more": "Lire la suite >"
    },
    "comments": {
      "title": "Laissez un commentaire",
      "name": "Nom",
      "email": "Courriel",
      "message": "Message",
      "post": "Publier le commentaire",
      "moderated": "Veuillez noter que les commentaires doivent être approvés avant d'être affichés",
      "success_moderated": "Votre commentaire a été soumis avec succès. Nous le publierons sous peu, suite à notre processus de modération.",
      "success": "Votre commentaire a été publié avec succès!",
      "comments_with_count": {
        "one": "{{ count }} commentaire",
        "other": "{{ count }} commentaires"
      }
    },
    "sidebar": {
      "recent_articles": "Messages récents",
      "categories": "Catégories",
      "video": "Dernière vidéo",
      "tags": "Nuage de tags"
    }
  },
  "cart": {
    "general": {
      "title": "Panier",
      "remove": "Retirer",
      "edit": "modifier",
      "note": "Instructions spéciales pour la commande",
      "carttotals":"Total du panier",
      "subtotal": "Sous-total",
      "grandtotal": "Total",
      "shipping_at_checkout": "Commander avec plusieurs adresses",
      "update": "Mettre à jour son panier",
      "continue":"Continuer les achats",
      "checkout": "Procéder au paiement",
      "empty": "Votre panier est vide.",
      "continue_browsing_html": "<a href=\"\/collections\/all\">Retourner au magasinage<\/a>.",
      "close_cart": "Fermer le panier",
      "shipping_calculator_error_message": "Erreur: Veuillez entrer vois information sur la livraison correctes",
      "shipping_calculator_success_many_rates": {
        "there_are": "Il y a",
        "shipping_rates_available_for": "Tarifs d'expédition disponibles pour",
        "starting_at": ", à partir de"
      },
      "shipping_calculator_success_one_rate": "Il ya un tarif disponible pour d'expédition",
      "shipping_calculator_success_no_rate": "Il n'y a aucune tarif disponible pour cet ordre et de destination expédition.",
      "shipping_calculator_success_at": "à"
    },
    "header": {
      "checkout": "Paiement",
      "total": "Le total:",
      "total_numb": "article(s)",
      "no_item": "Il n'y a aucun objet dans votre panier.",
      "remove_this_item": "Supprimer un objet"
    },
    "label": {
      "product": "Nom du produit",
      "price": "Prix unitaire",
      "quantity": "Qté",
      "update_cart": "Update Cart",
      "remove": "Remove",
      "total": "Total"
    },
    "shipping": {
      "title": "Estimation du port et des taxes.",
      "title_form": "Entrez votre destination pour obtenir une estimation des frais de port.",
      "country": "Pays",
      "state": "Etat",
      "zip": "Zip\/code postal",
      "submit_button": "Obtenez un devis",
      "submit_button_when_calculating": "Calculateur..."
    }
  },
  "collections": {
    "general": {
      "title": "Liste Collections",
      "all_of_collection": "Tout",
      "no_matches": "Aucun produit ne correspond à votre recherche.",
      "link_title": "Consultez la collection {{ title }}",
      "grid_view": "Grille",
      "list_view": "Liste",
      "shop_the_collection": "Boutique La Collection",
      "items_with_count": {
        "one": "{{ count }} Produits",
        "other": "{{ count }} Produits"
      },
      "clear": "Clair",
      "refine_by": "Affiner par",
      "clear_all": "Tout effacer",
      "filter": "Filtre",
      "showing": "Affichage",
      "of": "De",
      "previous": "Précédent",
      "next": "Suivant Suivant",
      "show_more": "Charger plus",
      "loading": "Chargement",
      "no_more_product": "Pas plus produit",
      "quickview": "Quick View"
    },
    "sidebar": {
      "categories": "Catégories",
      "shopby": "Magasiner par",
      "tags": "Filtres"
    },
    "sorting": {
      "title": "Trier par:",
      "featured": "En vedette",
      "best_selling": "Meilleurs vendeurs",
      "az": "A-Z",
      "za": "Z-A",
      "price_ascending": "Prix: faible à élevé",
      "price_descending": "Prix: élevé à faible",
      "date_descending": "Date: récent à ancien",
      "date_ascending": "Date: ancien à récent",
      "limit_16": "16",
      "limit_22": "22",
      "limit_44": "44",
      "limit_all": "Tout"
    },
    "limiter": {
      "title": "Afficher:",
      "limit_16": "16",
      "limit_22": "22",
      "limit_44": "44",
      "limit_all": "Tout"
    },
    "onboarding": {
      "modal_title": "Cette page affichera tous les produits de votre magasin",
      "no_products_html": "Il n'y a aucun produit pour l'instant, mais dès que vous commencerez à les ajouter, ils s'afficheront ici, qu'ils soient dans une collection ou non.",
      "add_product": "Ajouter un produit"
    },
    "onepage": {
      "seemore": "Voir plus"
    }
  },
  "contact": {
    "form": {
      "title": "Laisser un ",
      "title_after":"Message",
      "name": "Nom",
      "email": "Courriel",
      "phone": "Téléphone",
      "comment": "Comment",
      "send": "Envoyer le message",
      "submit":"soumettre",
      "post_success": "Merci de nous avoir avoir contacté. Nous vous reviendrons le plus rapidement possible."
    }
  },
  "customer": {
    "account": {
      "title": "Mon compte",
      "details": "Détails du compte",
      "view_addresses": "Voir les adresses",
      "return": "Retour au détails du compte"
    },
    "activate_account": {
      "title": "Activer le compte",
      "subtext": "Créez votre mot de passe pour activer le compte.",
      "submit": "Activer le compte",
      "cancel": "Refuser l'invitation",
      "password": "Mot de passe",
      "password_confirm": "Confirmer le mot de passe"
    },
    "addresses": {
      "title": "Votre adresse",
      "default": "Par défaut",
      "add_new": "Ajouter une nouvelle adresse",
      "edit_address": "Éditer l'adresse",
      "first_name": "Prénom",
      "last_name": "Nom",
      "company": "Compagnie",
      "address1": "Adresse 1",
      "address2": "Adresse 2",
      "city": "Ville",
      "country": "Pays",
      "province": "Province",
      "zip": "Code postal",
      "phone": "Téléphone",
      "set_default": "Définir comme adresse par défaut",
      "add": "Ajouter l'adresse",
      "update": "Mettre à jour l'adresse",
      "cancel": "Annuler",
      "edit": "Éditer",
      "delete": "Supprimer",
      "delete_message": "Etes-vous sûr que vous voulez supprimer cette adresse?"
    },
    "login": {
      "heading":"Connectez-vous ou créez un compte",
      "page_title": "Login",
      "title": "Utilisateurs enregistrés",
      "content": "Si vous avez un compte chez nous, identifiez-vous.",
      "email": "Adresse e-mail",
      "password": "Mot de passe",
      "forgot_password": "Mot de passe oublié?",
      "sign_in": "Se connecter",
      "log_in":"Identifiant",
      "cancel": "Retourner à la boutique",
      "guest_title": "Continuer en tant qu'invité",
      "guest_continue": "Continuer",
      "register": "Nouveaux utilisateurs",
      "register_content": "En créant un compte avec notre boutique, vous serez capable de procéder aux achats plus rapidement, d'ajouter plusieurs adresses d'expédition, de voir et suivre vos commandes sur votre compte et plus encore.",
      "register_button": "Créer un compte"
    },
    "logout": {
      "title": "Se déconnecter"
    },
    "orders": {
      "title": "Historique des commandes",
      "order_number": "Commande",
      "date": "Date",
      "payment_status": "Statut du paiement",
      "fulfillment_status": "Statut du traitement de la commande",
      "total": "Total",
      "none": "Vous n'avez pas placé de commande à ce jour."
    },
    "order": {
      "title": "Commande {{ name }}",
      "date": "Placée le {{ date }}",
      "cancelled": "Commande annulée le {{ date }}",
      "cancelled_reason": "Motif: {{ reason }}",
      "billing_address": "Adresse de facturation",
      "payment_status": "Statut du paiement",
      "shipping_address": "Adresse de livraison",
      "fulfillment_status": "Statut du traitement de la commande",
      "discount": "Rabais appliqué",
      "shipping": "Livraison",
      "tax": "Taxes",
      "product": "Produit",
      "sku": "SKU",
      "price": "Prix",
      "quantity": "Quantité",
      "total": "Total",
      "fulfilled_at": "Traitée le {{ date }}",
      "subtotal": "Sous-total"
    },
    "recover_password": {
      "title": "Réinitialiser votre mot de passe",
      "email": "Courriel",
      "submit": "Soumettre",
      "cancel": "Retour connexion",
      "subtext": "Nous vous ferons parvenir un courriel pour réinitialiser votre mot de passe.",
      "success": "Nous vous avons fait parvenir un courriel pour réinitialiser votre mot de passe."
    },
    "reset_password": {
      "title": "Réinitialiser le mot de passe du compte",
      "subtext": "Entrez un nouveau mot de passe pour {{ email }}",
      "submit": "Réinitialiser le mot de passe",
      "password": "Mot de passe",
      "password_confirm": "Confirmer le mot de passe"
    },
    "register": {
      "page_title": "Registre",
      "title": "Créer un compte",
      "title_form":"Information personnelle",
      "first_name": "Prénom",
      "last_name": "Nom",
      "email": "Courriel",
      "submit": "Soumettre",
      "cancel": "Retour à la boutique",
      "required":"* Champs obligatoires",
      "password": "Mot de passe",
      "message": "S'il vous plaît entrer les informations ci-dessous pour créer votre compte."
    }
  },
  "homepage": {
    "sections": {
      "frontpage_title": "Collection Frontpage",
      "featured_title": "Collections en vedette",
      "news_title": "Nouvelles récentes"
    },
    "onboarding": {
      "modal_title": "Nous y sommes presque...",
      "no_products_html": "Vous n'avez pas de produit dans votre collection Frontpage. Ce message apparaitra jusqu'à ce qu'un produit soit <a href=\"\/admin\/collections?tutorial=Frontpage\">ajouté à cette collection<\/a>.",
      "add_product": "Ajouter un produit",
      "product_title": "Titre du produit",
      "no_collections_html": "Vous n'avez pas de collection à afficher ici. <a href=\"\/admin\/custom_collections\">Ajoutez une ou plusieurs collections<\/a> pour compléter la page d'accueil par défaut.",
      "add_collection": "Ajouter une collection",
      "collection_title": "Titre de la collection"
    }
  },
  "layout": {
    "navigation": {
      "menu": "Menu"
    },
    "drawers": {
      "browse": "Explorer",
      "close_menu": "Fermer le menu"
    },
    "cart": {
      "title": "Panier",
      "items_count": {
        "one": "élément",
        "other": "éléments"
      }
    },
    "customer": {
      "account": "Compte",
      "logged_in_as_html": "Connecté en tant que {{ first_name }}",
      "log_out": "Se déconnecter",
      "log_in": "Se connecter",
      "create_account": "Créer un compte"
    },
    "footer": {
      "social_title": "Restez en contact",
      "newsletter_title": "Infolettre",
      "accepted_payments": "Méthodes de paiement acceptées"
    }
  }, 
  "wish_list": {
    "general": {
      "wishlist": "Wishlist",
      "add_to_wishlist": "Ajouter à la liste de souhaits",
      "browse_wishlist": "Parcourir la liste de souhaits",
      "product": "Produit", 
      "price": "Prix", 
      "remove": "has removed from wishlist",
      "quantity": "Quantité",
      "options": "Options",
      "no_item": "Il n'y a aucun élément dans la boîte de souhaits",
      "item_exist": "existe dans la liste de souhaits",
      "item_added": "a ajouté à la liste de souhaits réussie"
    }
  },
  "compare_list": {
    "general": {
      "compare": "Boîte de comparaison",
      "add_to_compare": "Ajouter pour comparer",  
      "price": "Prix", 
      "product": "Produit", 
      "remove": "a été retiré de la boîte de comparaison",
      "quantity": "Quantité",
      "options": "Options",
      "no_item": "Il n'y a aucun élément dans la boîte de comparaison",
      "item_exist": "existe en comparaison",
      "item_added": "a ajouté à la boîte de comparaison réussie",
      "features": "Caractéristiques",
      "actions": "Actes"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Produit précédent",
      "next_product_html": "Produit suivant &rarr;",
      "from_text_html": "À partir de {{ price }}",
      "sale_price": "Prix réduit",
      "regular_price": "Prix régulier",
      "related_products": "Acheté aussi",
      "sale": "Vente",
      "show_more": "Montre plus",
      "no_more_product": "Pas plus de produits"
    },
    "product": {
      "quickview": "aperçu rapide",
      "sold_out": "Épuisé",
      "on_sale": "En solde",
      "on_sale_from_html": "<strong>En solde<\/strong> {{ price }}",
      "unavailable": "Non disponible",
      "compare_at": "Était",
      "quantity": "Qty",
      "add_to_cart": "Le panier",
      "select_options": "Select Options",
      "tab_title_description": "Plus d'information",
      "tab_title_review": "Avis",
      "share": "Partager:",
      "availability": "Disponibilité:",
      "sku": "Sku:",
      "in_stock": "En stock",
      "out_of_stock": "Rupture de stock",
      "many_in_stock": "Beaucoup En Stock",
      "product_type": "Type de produit:",
      "product_vendor": "Vendeur:",
      "count_down": "Offres d'une durée limitée, en fin:"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "Votre carte-cadeau {{ shop }} d'une valeur de {{ value }}!",
      "subtext": "Voici votre carte-cadeau!",
      "disabled": "Désactivée",
      "expired": "Expirée le {{ expiry }}",
      "active": "Expire le {{ expiry }}",
      "redeem": "Entrez ce code lors du paiement pour utiliser votre carte-cadeau",
      "shop_link": "Boutique",
      "print": "Imprimer"
    }
  },
  "date_formats": {
    "month_day_year": "%d %B, %Y"
  }
}